const base = '/workspace-select';

export const workspaceSelectRoutes = {
  index: base,
} as const;
